module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "ded-title"
  }, [_c('b', [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are many people to thank for their contributions to this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to Roxane Cerda, the C&T acquisitions editor who believed in my first book, "), _c('i', [_vm._v("Modern Fabric Art Bowls")]), _vm._v(", and gave me the opportunity to write this second book to follow up with patterns and directions for round bowls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many thanks to my editor, Madison Moore, whose incredible patience and technical assistance have helped me from the very beginning of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another thank you to the many other people at C&T who worked with us on making this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many thanks to my good friend Martha McDonald. Her support, calm steadiness, and clear thinking made writing this book so much easier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And thanks to Madeleine Appell for letting me use some of her fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was lucky to come across Tres Rebecas, a craft shop in San Antonio, Texas with an incredible staff and a treasure chest of some of my favorite sold-out fabrics, some of which have been used in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since my first book, "), _c('i', [_vm._v("Modern Fabric Art Bowls")]), _vm._v(", was published, many crafters from many parts of the world have become my social media friends, and I thank you for all the great pictures of your fabric bowls and the encouragement to take on this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My husband, Ken Fisher, isn’t a crafter, but no one has encouraged me more.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg3_1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9091d7de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_ack.vue
// module id = 66
// module chunks = 0